import { Decoration_Type } from "./../../ricos-types/index.js";
import { TiptapContentResolver } from "./../../toolbars-v3/ContentResolver.js";
const isAnchorInText = TiptapContentResolver.create((content) => {
  if (Array.isArray(content)) {
    const node = content.find((node2) => {
      return node2.type.name === "text";
    });
    return node?.marks.some((mark) => mark.type.name === Decoration_Type.ANCHOR);
  }
  return false;
});
export {
  isAnchorInText
};
//# sourceMappingURL=is-anchor-in-text.js.map
